module.exports = __webpack_public_path__ + "img/StealthGirl.3e00cf30.png";